import type { ChangeEventHandler, FocusEventHandler, Ref } from "react";

import { SERVICE_LINES } from "@/features/projects/api";
import { ServiceTile } from "@/features/projects/components/ServiceIcon";
import { useT } from "@/shared/i18n/useT";
import { ChoiceCards } from "@/shared/ui/ChoiceCards";

interface ServiceChoiceCardsProps {
  /** Spread the form's register("service") here. */
  name: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onBlur: FocusEventHandler<HTMLInputElement>;
  ref: Ref<HTMLInputElement>;
  disabled?: boolean;
}

/** The project's service line, as cards with their coloured tiles. */
export function ServiceChoiceCards(props: ServiceChoiceCardsProps) {
  const t = useT();
  return (
    <ChoiceCards
      legend={t("newProject.service")}
      options={SERVICE_LINES.map((line) => ({
        value: line,
        label: t(`service.${line}`),
        icon: <ServiceTile service={line} size="sm" />,
      }))}
      columns={2}
      {...props}
    />
  );
}
